import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/BackgroundVideo.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/components/AuthorCard.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/components/BlogCardWide.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/blog/author/[slug]/page.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/image-component.js");
